import { render, staticRenderFns } from "./ConsultCorporation.vue?vue&type=template&id=5a696048&scoped=true&"
import script from "./ConsultCorporation.vue?vue&type=script&lang=js&"
export * from "./ConsultCorporation.vue?vue&type=script&lang=js&"
import style0 from "./ConsultCorporation.vue?vue&type=style&index=0&id=5a696048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a696048",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCardActions,VCol,VContainer,VForm,VRow,VTextField,VTextarea})
